import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NewYork = () => {
  return (
    <StatePropertyTaxPage
      stateName="New York"
      processDescription="Property owners may challenge their assessment through the grievance process by filing with the local board of assessment review (BAR). Appeals must be filed on Grievance Day or during the specified grievance period. If unsuccessful, further appeals may be made to the state's Real Property Tax Services."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices and tentative assessment rolls are typically made available in May, with Grievance Day scheduled for the fourth Tuesday in May."
      valuationAsOfDate="March 1"
      valuationAsOfDateExplanation="New York typically assesses property as of the taxable status date, which is March 1 in most municipalities. This spring assessment date captures property conditions as they emerge from winter."
      deadlineExplanation="Property owners must file grievances on Grievance Day (fourth Tuesday in May) or during the specified grievance period. Some municipalities may have extended filing periods, but the deadline is typically in late May or early June."
    />
  );
};

export default NewYork;